import { z } from 'zod';

/**
 * Why a session ended. These values are shared with `arena-agent`
 * (`Arena.Agent.Core/SessionEndReason.cs`) and stored as-is in
 * `session.end_reason`, so they never change once a session has used them.
 */
export const SESSION_END_REASONS = [
  'USER_ENDED',
  'WORKSTATION_LOCKED',
  'SHUTDOWN',
  'IDLE_TIMEOUT',
  'HEARTBEAT_LOST',
  'ADMIN_CLOSED',
] as const;

export const sessionEndReasonSchema = z.enum(SESSION_END_REASONS);
export type SessionEndReason = z.infer<typeof sessionEndReasonSchema>;

/** A session with a youth in it is warned this long before a remote lock (RN-C2). */
export const REMOTE_LOCK_WARNING_SECONDS = 5 * 60;

/** With no heartbeat for this long the server closes the session (`HEARTBEAT_LOST`). */
export const HEARTBEAT_LOST_AFTER_SECONDS = 5 * 60;
